import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { JsonService } from 'src/app/services/core/json.service';
import { environment } from 'src/environments/environment';

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

const ContactAuthorityApiResources = {
  base: createUrl('contact-authorities'),
};

@Injectable({
  providedIn: 'root',
})
export class ContactAuthorityService {
  constructor(private http: HttpClient, private jsonService: JsonService) {}

  getList(params: any = {}): Observable<any> {
    let httpParams = new HttpParams();
    if (params.search) httpParams = httpParams.set('search', params.search);
    if (params.sort_by) httpParams = httpParams.set('sort_by', params.sort_by);
    if (params.sort_order) httpParams = httpParams.set('sort_order', params.sort_order);
    if (params.per_page) httpParams = httpParams.set('per_page', params.per_page);
    if (params.page) httpParams = httpParams.set('page', params.page);

    return this.http
      .get<any>(ContactAuthorityApiResources.base, { params: httpParams })
      .pipe(
        tap((data) => this.jsonService.doStringify(data)),
        catchError(this.errorHandler)
      );
  }

  create(model: any): Observable<any> {
    return this.http
      .post<any>(ContactAuthorityApiResources.base, model)
      .pipe(
        tap((data) => this.jsonService.doStringify(data)),
        catchError(this.errorHandler)
      );
  }

  update(id: any, model: any): Observable<any> {
    return this.http
      .put<any>(`${ContactAuthorityApiResources.base}/${id}`, model)
      .pipe(
        tap((data) => this.jsonService.doStringify(data)),
        catchError(this.errorHandler)
      );
  }

  delete(id: any): Observable<any> {
    return this.http
      .delete<any>(`${ContactAuthorityApiResources.base}/${id}`)
      .pipe(
        tap((data) => this.jsonService.doStringify(data)),
        catchError(this.errorHandler)
      );
  }

  setDefault(id: any): Observable<any> {
    return this.http
      .post<any>(`${ContactAuthorityApiResources.base}/${id}/set-default`, {})
      .pipe(
        tap((data) => this.jsonService.doStringify(data)),
        catchError(this.errorHandler)
      );
  }

  private errorHandler(error: any): Observable<never> {
    return throwError(error);
  }
}
